import React, { useState, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import Input from '../../shared/components/FormElements/Input/Input';
import Button from '../../shared/components/FormElements/Button/Button';
import { VALIDATOR_REQUIRE } from '../../shared/util/validator';
import { useForm } from '../../shared/hooks/form-hook';
import { useHttpClient } from '../../shared/hooks/http-hook';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import { AuthContext } from '../../shared/context/auth-context';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import './NewInterview.css';
import MainNavigation from '../../components/MainNavigation';

const NewInterview = () => {

  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [isStarted, setIsStarted] = useState(true);
  const [isTitle, setIsTitle] = useState(false);
  const [isDescription, setIsDescription] = useState(false);
  const [isQuestion, setIsQuestion] = useState(false);
  const [yPosition, setYPosition] = useState('22%')

  const [formState, inputHandler] = useForm(
    {
      title: {
        value: '',
        isValid: false
      },
      description: {
        value: '',
        isValid: false
      },
      questions: {
        value: '',
        isValid: true
      }
    },
    false
  );

  const interviewSubmitHandler = async event => {
    setYPosition('180%');
    event.preventDefault();
    setTimeout(async()=>{
      try {
        const response = await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+'/new', 'POST',
        JSON.stringify({
          title: formState.inputs.title.value,
          description: formState.inputs.description.value,
          questions: formState.inputs.questions.value,
          userId: auth.userId
        }),
        {
          'Content-Type':'application/json',
          Authorization: 'Bearer '+auth.token
        })
  
        navigate(`/interview/${response.interview._id}/questions`);
      } catch (err) {
  
      }
    }, 1200);
  };

  const clickStartHandler = () => {
    setIsStarted(false);
    setTimeout(()=>{
      setIsTitle(true);
    }, 1000);
    setYPosition('44%');
  };

  const backHandler = () => {
    setIsTitle(false);
    setTimeout(()=>{
      setIsStarted(true);
    }, 1000);
    setYPosition('22%');
  };

  const nextHandler = () => {
    setIsTitle(false);
    setTimeout(()=>{
      setIsDescription(true);
    }, 1000);
    setYPosition('66%');
  };

  const backHandler1 = () => {
    setIsDescription(false);
    setTimeout(()=>{
      setIsTitle(true);
    }, 1000);
    setYPosition('44%');
  };

  const nextHandler1 = () => {
    setIsDescription(false);
    setTimeout(()=>{
      setIsQuestion(true);
    }, 1000);
    setYPosition('88%');
  };

  const backHandler2 = () => {
    setIsQuestion(false);
    setTimeout(()=>{
      setIsDescription(true);
    }, 1000);
    setYPosition('66%');
  };

  return (
    <React.Fragment>
    <ErrorModal error={error} onClear={clearError}/>
    {isLoading && <LoadingSpinner asOverlay />}
    <div className='newinterview-content'>
    {!isLoading && <MainNavigation />}    
      <form className="new-plan-form" onSubmit={interviewSubmitHandler}>
        <AnimatePresence>
        {!isLoading && isStarted && !isTitle && !isDescription &&
        <motion.div 
          className='newplan-description'
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          exit={{ opacity: 0, scale: 1 }}
        >
          <div className='description-textbox'>
          <h1>Get Started</h1>
          <p>Let’s start practising for your next Interview by inputting title, and job description. If you have questions to practise at hand, put them in the question section. Make sure to have updated information on resume section.</p>
          <motion.div 
            className='create-session-wrapper'
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <div className='create-session-button'>
              <Button type='button' onClick={clickStartHandler} transparent><p style={{ color: 'white', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>CREATE NEW SESSION</p></Button>
            </div>
          </motion.div>
          </div>
        </motion.div>
        }
        </AnimatePresence>
        <AnimatePresence>
        {!isLoading && !isStarted && isTitle && !isDescription &&
        <motion.div 
          className='flex-containera'
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          exit={{ opacity: 0, scale: 1 }}
        >
          <div className='description-textbox'>
            <h2>What is your interview title?</h2>
            <p>Descriptive title might help improve the quality of the questions and feedbacks.</p>
          </div>
          <div className='flex-child'>
            <Input
              id="title"
              element="input"
              type="text"
              placeholder="ex.) Minerva Interview"
              validators={[VALIDATOR_REQUIRE()]}
              errorText="enter the title of the interview"
              onInput={inputHandler}
              initialValue={formState.inputs.title.value}
              initialValid={formState.inputs.title.isValid}
            />
          </div>
          <div className='back-next-buttons'>
            <div className='back-button'>
              <Button type='button' onClick={backHandler} transparent><p style={{ color: 'black', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>BACK</p></Button>
            </div>
            <div className='next-button'>
              <Button type='button' onClick={nextHandler} transparent disabled={!formState.inputs.title.isValid}><p style={{ color: 'white', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>NEXT</p></Button>
            </div>
          </div>
        </motion.div>
        }
        </AnimatePresence>
        <AnimatePresence>
        {!isLoading && !isStarted && !isTitle && isDescription &&
        <motion.div 
          className='level-containera'
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          exit={{ opacity: 0, scale: 1 }}
        >
          <div className='description-textbox'>
            <h2>Can you provide me a job description?</h2>
            <p>Please copy and paste job description here. (if it is longer than 500 words, please make it shorter!)</p>
          </div>
          <Input
            id="description"
            element="textarea"
            rows={5}
            placeholder="ex.) Interview is for AI Lab intern. It mainly asks motivations behind participation."
            validators={[VALIDATOR_REQUIRE()]}
            errorText="enter the description of the interview under 200 words."
            onInput={inputHandler}
            initialValue={formState.inputs.description.value}
            initialValid={formState.inputs.description.isValid}
          />
          <div className='back-next-buttons'>
            <div className='back-button'>
              <Button type='button' onClick={backHandler1} transparent><p style={{ color: 'black', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>BACK</p></Button>
            </div>
            <div className='next-button'>
              <Button type='button' onClick={nextHandler1} transparent disabled={!formState.inputs.description.isValid}><p style={{ color: 'white', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>NEXT</p></Button>
            </div>
          </div>
        </motion.div>
        }
        </AnimatePresence>
        <AnimatePresence>
        {!isLoading && !isStarted && !isTitle && !isDescription && isQuestion &&
        <motion.div 
          className='level-containera'
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0, duration: 0.5 }}
          exit={{ opacity: 0, scale: 1 }}
        >
          <div className='description-textbox'>
            <h2>Do you have questions you want to practice? (Optional)</h2>
            <p>List up to 5 questions here</p>
          </div>
          <Input
            id="questions"
            element="textarea"
            rows={5}
            placeholder="ex.) -What is your plan after graduation"
            validators={[]}
            errorText="Something is wrong here."
            onInput={inputHandler}
            initialValid={formState.inputs.questions.isValid}
            initialValue={formState.inputs.questions.value}
          />
          <div className='back-next-buttons'>
            <div className='back-button'>
              <Button type='button' onClick={backHandler2} transparent><p style={{ color: 'black', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>BACK</p></Button>
            </div>
            <div className='next-button1'>
              <Button type='submit' transparent disabled={!formState.inputs.description.isValid || !formState.inputs.title.isValid}><p style={{ color: 'white', marginBottom: 0, marginTop: 0, width: '100%', letterSpacing: '0.2rem' }}>CREATE INTERVIEW</p></Button>
            </div>
          </div>
        </motion.div>
        }
        </AnimatePresence>
      </form>
      <motion.img className='rocket' alt='' src='rocket.png' animate={{
          bottom: yPosition,
        }}
        transition={{
          type: 'spring',
          stiffness: 100,
          damping: 30,
          duration: 1,
        }}/>
    </div>
    </React.Fragment>
  );
};

export default NewInterview;